import React from 'react';
import { MainLayout } from '@components';
import CTsComponents from './CTScan';

export default function CTsPage(props) {
  return <MainLayout footer="main" children={<CTsComponents {...props} />} />;
}
